<template>
  <div class="index-container"></div>
</template>

<script>
export default {
  name: "SinglePrintIndex",
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
</style>